import { useState, useEffect } from "react";
// react redux
import { useSelector } from "react-redux";
// hooks
import usePageParams from "../../hooks/usePageParams";
// mui
import { Stack, Box, Button } from "@mui/material";
// axios
import EnhancedAxios from "../../axios/EnhancedAxios";
import { AxiosResponse, AxiosError } from "axios";
// components
import {
    PageTitle,
    SortBox,
    SearchBox,
    TableGrid,
    LinkButton,
    StatusFilterBox,
    ThreeDotsLoader,
} from "../../components";
// cols
import { deliverersCols } from "../../utils/gridCols/deliverersCols";
// icons
import { MdAdd } from "react-icons/md";
// types
import { ReduxUserReducerState } from "../../types/global";
// alerts
import { successAlert, errorAlert } from "../../utils/alerts/alerts";
import CityFilterBox from "../../components/filter/CityFilterBox";
import AreaFilterBox from "../../components/filter/AreaFilterBox";

const Deliverers = () => {
    const userToken = useSelector(
        (state: ReduxUserReducerState) => state.user.userToken
    );
    const { page, setPage } = usePageParams();
    const [distributors, setDistributors] = useState([]);
    const [sortValue, setSortValue] = useState<string>("-created_at");
    const [searchValue, setSearchValue] = useState("");
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [totalItems, setTotalItems] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [filterValues, setFilterValues] = useState<Record<string, string>>({
        status: "",
        cities: "",
        areas: "",
    });
    // get all distributors
    useEffect(() => {
        setLoading(true);
        let endpoint = `/admin/distributors?page=${page}&paginate=${itemsPerPage}&sorts=${sortValue}&q=${searchValue}&filters=`;
        if (filterValues?.status) endpoint += `status:${filterValues.status},`;
        if (filterValues?.cities) endpoint += `cities:${filterValues?.cities},`;
        if (filterValues?.areas) endpoint += `areas:${filterValues?.areas},`;
        EnhancedAxios(null, userToken)
            .get(endpoint)
            .then((res: AxiosResponse) => {
                setDistributors(res.data.data);
                setTotalItems(res.data.meta.total);
                setLoading(false);
            })
            .catch((error: AxiosError) => {
                errorAlert(error);
            });
    }, [page, sortValue, searchValue, filterValues]);
    return (
        <Stack gap="20px">
            <PageTitle title="ادراة الموزعين" />
            <Box>
                <LinkButton
                    text="اضافة موزع"
                    to="/add-deliverer"
                    icon={<MdAdd />}
                />
            </Box>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap="10px"
                flexWrap="wrap"
            >
                <SearchBox
                    searchValue={searchValue}
                    setSearchValue={setSearchValue}
                />
                <SortBox sortValue={sortValue} setSortValue={setSortValue} />
                <StatusFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
                <CityFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
                <AreaFilterBox
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                />
            </Box>
            {loading ? (
                <ThreeDotsLoader />
            ) : distributors.length === 0 ? (
                <p className="center-text">لا يوجد موزعين لعرضهم</p>
            ) : (
                <TableGrid
                    rows={distributors}
                    cols={deliverersCols}
                    itemsPerPage={itemsPerPage}
                    totalItems={totalItems}
                    currentPage={page}
                    setCurrentPage={setPage}
                />
            )}
        </Stack>
    );
};

export default Deliverers;
